import { render } from "./VueCalendar.vue?vue&type=template&id=1dec5e0e"
import script from "./VueCalendar.vue?vue&type=script&lang=js"
export * from "./VueCalendar.vue?vue&type=script&lang=js"

import "./VueCalendar.vue?vue&type=style&index=0&id=1dec5e0e&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__